export enum CognitoRoles {
    ADMIN = 1,
    CARGA = 2,
    APROBADOR = 3,
    MANAGER = 4,
    CONSULTA = 5,
    INTEGRADOR = 6,
    AGENTE = 7
}